import {Extent} from 'ol/extent';

export const DEF_LINE_COLOR: string = 'red';
export const DEF_MAP_CLUSTER_CLICK_TOLERANCE: number = 40;
export const DEF_MAP_MIN_ZOOM: number = 1;
export const DEF_MAP_MAX_ZOOM: number = 16;
export const DEF_MAP_ZOOM_IN: number = 12;
export const MAP_ZOOM_ON_CLICK_TRESHOLD: number = 6;
export const FEATURES_IN_VIEWPORT_ZOOM_MIN: number = 10;
export const FEATURES_IN_VIEWPORT_ZOOM_MAX: number = 12;
export const DEF_ZOOM_ON_CLICK: number = 10;
export const DEF_MAP_MAX_PBF_ZOOM = 13;
export const DEF_XYZ_URL: string = 'https://api.webmapp.it/tiles/{z}/{x}/{y}.png';
export const initExtent: Extent = [-180, -85, 180, 85];
export const ICN_PATH: string = 'assets/icons/pois';
export const CLUSTER_DISTANCE: number = 60;
export const scaleUnits = 'metric';
export const scaleMinWidth = 50;
export const SWITCH_RESOLUTION_ZOOM_LEVEL = 10;
export const DEF_MAP_ROTATION_DURATION: number = 400;
export const FEATURE_COLLECTION_DISABLE_ZOOM_TRESHOLD = 2;
export const FEATURE_COLLECTION_STROKE_COLOR = 'rgba(245, 159, 26, 1)';
export const FEATURE_COLLECTION_FILL_COLOR = 'rgba(245, 159, 26, 0.4)';
export const FEATURE_COLLECTION_STROKE_WIDTH = 4;
export const BOX_SIZE_VMIN = 65;
export const TILES_DOWNLOAD_ZOOM_MIN = 10;
export const GET_TILES_BY_GEOMETRY_MIN_ZOOM = 5;
export const GET_TILES_BY_GEOMETRY_MAX_ZOOM = 16;
/** Zoom fisso per query on-demand tracce vicine (indipendente dallo zoom mappa corrente). */
export const LOCATION_RANGE_TILE_ZOOM = 8;
/** Raggio in metri entro cui cercare tracce vicine alla posizione GPS. */
export const LOCATION_RANGE_RADIUS_M = 1500;
export const RENDER_BUFFER = 50;
export const MIN_ZOOM_FOR_HOVER = 10;
